module.exports = __webpack_public_path__ + "img/profile-placehold.efab4bc8.svg";